import { StepperComponent } from "app/components/banker/bidders/StepperComponent";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { JBStepperComponent } from "./JBStepperComponent";
import JBOnlineForm from "./JBOnlineForm";
import { useSelector } from "react-redux";
import { getAuctionEventById } from "services";
import OfflineKYCInfoModal from "./OfflineKYCInfoModal";

export const JBOnlineFormWrapper = () => {
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const [activeStep, setActiveStep] = useState(0);
  const [allBiddersData, setAllBiddersData] = useState<any>();
  const [allErrorsData, setAllErrorsData] = useState<any>([]);
  const router = useRouter();
  const { bidder_type, id, bidders_count } = router.query as {
    bidder_type?: string;
    id?: string;
    bidders_count?: string;
  };
  const [eventData, setEventData] = useState({});
  const [openOfflineInfoModel, setOpenOfflineInfoModel] = useState(false);
  const [kycMode, setKycMode] = useState("online"); // 'online' or 'offline'
  const init = async () => {
    const data: any = await getAuctionEventById(id);
    setEventData(data);
  };
  const handleBackClick = () => {
    router.replace("/");
  };

  useEffect(() => {
    if (bidders_count) {
      const biddersArray = Array.from(
        { length: Number(bidders_count) },
        (_, index) => {
          // Pre-populate first bidder with user data
          if (index === 0) {
            return {
              user_type: { label: "Individual", value: "individual" },
              name: onboardingData?.name || "",
              email:
                user?.attributes?.find((data: any) => data.type === "email")
                  ?.value || "",
              pan: onboardingData?.pan || "",
              // aadhar_number: onboardingData?.aadhaar || "",
              mobile_number:
                user?.attributes
                  ?.find((data: any) => data.type === "mobile_number")
                  ?.value?.replace(/^\+91/, "") || "",
            };
          }
          return {
            user_type: { label: "Individual", value: "individual" },
            name: "",
            email: "",
            pan: "",
            // aadhar_number: "",
            mobile_number: "",
          };
        }
      );
      setAllBiddersData(biddersArray);
    }
    if (id) {
      init();
    }
  }, [bidders_count, onboardingData, user, id]);

  return (
    <div className="w-full">
      {/* Back Button */}
      <div className="mb-4">
        <button
          onClick={handleBackClick}
          className="flex items-center gap-2 text-brand-textLightGrey hover:text-brand-orange transition-colors duration-200"
        >
          &larr;
          <span className="text-sm font-medium">Back</span>
        </button>
      </div>

      <div className="lg:flex mt-5 w-full">
        <JBStepperComponent
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          totalSteps={Number(bidders_count) ? Number(bidders_count) : 0}
        />
        <JBOnlineForm
          setActiveStep={setActiveStep}
          eventData={eventData}
          activeStep={activeStep}
          allBiddersData={allBiddersData}
          currentBidderData={allBiddersData ? allBiddersData[activeStep] : []}
          setCurrentBidderData={setAllBiddersData}
          totalSteps={Number(bidders_count) ? Number(bidders_count) : 0}
          setAllErrorsData={setAllErrorsData}
          allErrorsData={allErrorsData}
          setOpenOfflineInfoModel={setOpenOfflineInfoModel}
          setKycMode={setKycMode}
          kycMode={kycMode}
        />
        <OfflineKYCInfoModal
          open={openOfflineInfoModel}
          onClose={() => setOpenOfflineInfoModel(false)}
        />
      </div>
    </div>
  );
};
